import Button from '@components/formControls/Button'
import Box from '@mui/material/Box'
import { Theme, styled } from '@mui/material/styles'
import { colors, componentSizes } from '@theme/variables'

export const ShortlistPageWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const ShortlistPagePaper = styled('div')`
  margin: 0 ${componentSizes.smDistance} 0 0;
`
export const ShortlistPagePaperInner = styled('div')`
  background-color: ${colors.white};
  padding: ${componentSizes.smDistance} ${componentSizes.smDistance} 0;
  border: 1px solid #dadada;
  position: relative;
  overflow: hidden;
`
export const ShortlistTableScrollbarWrapper = styled('div')`
  margin-top: auto;
  position: sticky;
  bottom: 0;
  z-index: 10;
  width: 100%;
  /* We need to subtract exactly 365px because this is a static width of Chat Widget.
  In this case scrollbar always will have a maximum possible width of full container except the width of Chat Widget,
  But no more than 862px as required per designs  */
  width: calc(100% - 365px);
  max-width: 862px;
`
export const ShortlistTableScrollbar = styled('div')`
  padding: 0 ${componentSizes.smDistance};
`

export const ShortlistTitleContainer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`

export const ShortlistButtonsBox = styled('div')`
  display: flex;
  align-items: center;
  align-self: flex-end;
  gap: 10px;
`

export const ShortListTitleInner = styled('div')`
  display: flex;
  align-items: center;
`

export const ShortlistCounterContainer = styled('div')`
  flex: 0 0 auto;
`

export const TableNavigationBox = styled(Box)`
  margin-top: 4px;
  margin-bottom: ${componentSizes.smDistance};

  &:first-child {
    margin: ${componentSizes.smDistance} 0 0;
  }
  &:last-child {
    margin: 0 0 ${componentSizes.smDistance};
  }
`

export const ShortlistTitleDivider = styled('div')`
  width: 0;
  height: 14px;
  border-left: 1px solid ${colors.lightGrey};
  margin: 7px;
`

export const TextButton = styled(Button)`
  padding: 0;
  margin: 0;
  justify-content: flex-start;

  &.Mui-disabled {
    background-color: transparent;
  }

  &:not(:last-child):enabled {
    margin-right: 5px;
  }
`

export const TopTabsNavigationContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-left: ${componentSizes.smDistance};
  margin-bottom: ${componentSizes.smDistance};
  max-height: 48px;
`

export const TabsWrapper = styled('div')`
  max-width: 60%;
  margin-right: 40px;
`

export const ActionItemsWrapper = styled('div')`
  display: flex;
  align-items: center;
`

export const EmptyProfilesWrapper = styled('div')`
  width: 100%;
  height: 100%;

  flex: 1 1 auto;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`

export const EmptyProfilesInner = styled('div')`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  max-width: 450px;
`

export const EmptyShortlistPicture = styled('img')`
  width: 264px;
  height: 264px;
  margin-top: 16px;
  margin-bottom: 16px;
`

export const EmptyShortlistButton = styled(Button)`
  margin-bottom: 30px;

  padding: 12px 27px;
  height: 50px;
  border-radius: 58px;

  font-weight: 700;
  font-size: 20px;
  background-color: #3eabe3;
  color: ${colors.white};
`

export const StyledAddIconWrapper = styled('div')`
  width: 12px;
  height: 12px;
  overflow: hidden;
`

export const ManageColumnsWrapper = styled('div')`
  display: flex;
  border-radius: 18px;
  border: 1px solid;
  padding: 5px 2px 5px 13px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-color: ${colors.primary};
  color: ${colors.primary};
  width: ${(props: { $width: string }) => props.$width};
  gap: 5px;
  margin-left: auto;
  box-shadow: 2px 4px 2px 0px #2c607b26;
`

export const ManageFiltersWrapper = styled('div')`
  display: flex;
  border-radius: 18px;
  border: 1px solid;
  padding: 5px 2px 5px 13px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border-color: ${colors.primary};
  color: ${colors.primary};
  gap: 5px;
  margin-left: auto;
  box-shadow: 2px 4px 2px 0px #2c607b26;
  background-color: ${(props: { $filtersApplied: boolean }) => (props.$filtersApplied ? `${colors.primary}` : `${colors.white}`)};
`

export const ManageFiltersText = styled('span')`
  display: inline-block;
  color: ${(props: { $filtersApplied: boolean }) => (props.$filtersApplied ? `${colors.white}` : `${colors.primary}`)};
`

export const ManageColumnsText = styled('span')`
  display: inline-block;
`

export const ManageColumnsIconSeparator = styled('span')`
  color: #358fbe;
  font-size: 15px;
`

export const TagDropdownButton = styled(Box)`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 3px 7px 3px 12px;
  border-radius: 16px;
  font-weight: 400;
  font-size: 14px;
  max-height: 24px;

  ${(props: { backgroundColor: string }) =>
    props.backgroundColor ? `background-color: ${props.backgroundColor};` : `${colors.primary};`}
  ${(props: { color: string }) => (props.color ? `color: ${props.color};` : `${colors.white};`)}
  ${(props: { disabled: boolean }) => (props.disabled ? 'cursor: default; pointer-events: none;' : 'cursor: pointer;')}
    ${({ theme }: { theme: Theme }) => theme.breakpoints.down('sm')} {
    font-size: 12px;
  }

  & svg {
    transition: 0.05s;
    fill: ${(props: { arrowColor?: string }) => (props.arrowColor ? props.arrowColor : colors.white)}
    font-size: 32px;
  }
`

export const TagNameWrapper = styled(Box)`
  display: flex;
  align-items: center;
  text-wrap: nowrap;
`

export const TagPickerWrapper = styled('div')`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 26px;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  width: 100%;
  &:hover {
    background: #f2f2f2;
  }

  &:first-of-type {
    margin-top: 16px;
  }
  &:last-of-type {
    margin-bottom: 16px;
  }
`

export const MoveSuccessNotification = styled('div')`
  display: flex;
  padding: 0 6px 0 10px;
  background: #e9f2ea;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #113214;
  cursor: pointer;
  margin-left: 15px;
  align-items: center;
  justify-content: center;
`
